Ext.define('SA.VectorMapCollapsibleInsetMap', {
    alias: 'widget.vector-map-collapsible-inset-map',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-collapsible-inset-map',

    initComponent() {
        var {maxExtent, style} = this;

        this.items = [
            {
                xtype: 'vector-map-inset-map',
                maxExtent,
                style
            }, {
                xtype: 'component',
                autoEl: 'button',
                cls: 'sa-vector-map-collapsible-inset-map-collapse-button',
                itemId: 'collapseButton',

                html: [
                    '<svg class="sa-vector-map-collapsible-inset-map-collapse-button-arrow sa-vector-map-collapsible-inset-map-collapse-button-arrow-bottom-right">',
                        '<use href="#sa-icon-arrow-bottom-right"></use>',
                    '</svg>',
                    '<svg class="sa-vector-map-collapsible-inset-map-collapse-button-arrow sa-vector-map-collapsible-inset-map-collapse-button-arrow-top-left">',
                        '<use href="#sa-icon-arrow-top-left"></use>',
                    '</svg>'
                ]
            }
        ];

        this.callParent();

        this.collapseButton = this.down('#collapseButton');
        this.map = this.down('vector-map-inset-map');
    },

    getCenter() {
        return this.map.getCenter();
    },

    initEvents() {
        this.callParent();

        this.collapseButton.getEl().on('click', () => this.getEl().dom.classList.toggle('sa-vector-map-collapsible-inset-map-collapsed'));
    },

    onMove(callback, scope) {
        this.map.onMove(callback, scope);
    },

    onMoveEnd(callback, scope) {
        this.map.onMoveEnd(callback, scope);
    },

    onWebGLContextLost(callback, scope) {
        this.map.onWebGLContextLost(callback, scope);
    },

    setExtentAndZoom(extent, zoom, options) {
        this.map.setExtentAndZoom(extent, zoom, options);
    }
});